<template>
    <div>
      <el-row style="margin-bottom:10px;">
        <!-- <el-col :span="8" >
          <el-select v-model='businessIds' clearable multiple>
                    <el-option
                v-for="item in getBusinessList_data.data||[]"
                :key="item.businessId"
                :label="item.businessName"
                :value="item.businessId">
              </el-option>
              </el-select>
        </el-col> -->
        <el-col :span="6" >
          <el-button
          v-if="addProjectBusinessClass"
             @click="$form('addProjectBusinessClass'),getProjectBusinessClassNotHas({pageSize:0})"
            size='small'
            type="primary"
            style="float:right"
            icon='el-icon-circle-plus'
          >添加业务分类
          </el-button>
        </el-col>
      </el-row>
      <myform
      :viewobj='{
          addProjectBusinessClass:  [ "新增项目业务分类", "el-icon-circle-plus" ]
        }'
        @close='$form("addProjectBusinessClass","reset"),getProjectBusinessClass({projectId})'
      @confirm='myformaddProjectBusinessClass' >
        <template v-slot:bcIds="{Myformdata}" >
              <el-select v-model='Myformdata.bcIds' clearable multiple>
                    <el-option
                v-for="item in getProjectBusinessClassNotHas_data.data||[]"
                :key="item.bcId"
                :label="item.bcName"
                :value="item.bcId">
              </el-option>
              </el-select>
          <el-button type="primary" icon="el-icon-circle-plus"
          @click="$form('addProjectBusinessClass','submit').then(s=>getProjectBusinessClass({projectId:row.projectId}))">添加</el-button>
          </template>
  
        <hide slot='projectId' />
      </myform>
  
      <mytable
        :tableColums='tableColums_getProjectBusinessClass'
        api='getProjectBusinessClass'
        xupdateapi='updateBusiness'
        :height="H-165" >
      </mytable>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        businessIds:[],
        projectId:null,
        tableColums_getProjectBusinessClass: {
          $selection: false,
          bcName: '业务分类名称',
          $operation: this.deleteProjectBusinessClass && [
            '操作', 200,
  
            `@text: 删除#danger
           @click: _confirm('确定要删除吗?')
                   .trigger('deleteProjectBusinessClass',{ypbcId:$row.ypbcId})
                   .trigger('getProjectBusinessClass',{projectId})
          `,
          ],
        },
  
  
      };
    },
  
    watch: {
  
    },
  
    methods: {
      myformaddProjectBusinessClass(submit, Myformdata) {
        Myformdata.projectId = A.local('$projectId');
        submit();
      },
    },
  
    created() {
      this.getProjectBusinessClass({projectId:A.local('$projectId')});
      this.projectId=A.local('$projectId')
      console.log(this.Myformdata)
      this.getProjectBusinessClassNotHas({projectId:A.local('$projectId')});
    }
  };
  </script>
  
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/views/bussiness/BussinessChange.vue